/* eslint-disable @typescript-eslint/camelcase */
import ar from './localeTranslations/ar.json';
import cs_cz from './localeTranslations/cs_cz.json';
import da_dk from './localeTranslations/da_dk.json';
import de_de from './localeTranslations/de_de.json';
import el_gr from './localeTranslations/el_gr.json';
import en from './localeTranslations/en.json';
import en_au from './localeTranslations/en_au.json';
import en_gb from './localeTranslations/en_gb.json';
import en_in from './localeTranslations/en_in.json';
import en_us from './localeTranslations/en_us.json';
import eo from './localeTranslations/eo.json';
import es_es from './localeTranslations/es_es.json';
import es_mx from './localeTranslations/es_mx.json';
import et_ee from './localeTranslations/et_ee.json';
import et_et from './localeTranslations/et_et.json';
import fi_fi from './localeTranslations/fi_fi.json';
import fr_be from './localeTranslations/fr_be.json';
import fr_ca from './localeTranslations/fr_ca.json';
import fr_fr from './localeTranslations/fr_fr.json';
import hu_hu from './localeTranslations/hu_hu.json';
import in_id from './localeTranslations/in_id.json';
import in_in from './localeTranslations/in_in.json';
import is_is from './localeTranslations/is_is.json';
import it_it from './localeTranslations/it_it.json';
import ja_jp from './localeTranslations/ja_jp.json';
import ko_kr from './localeTranslations/ko_kr.json';
import lt_lt from './localeTranslations/lt_lt.json';
import lv_lv from './localeTranslations/lv_lv.json';
import ms from './localeTranslations/ms.json';
import nl_be from './localeTranslations/nl_be.json';
import nl_nl from './localeTranslations/nl_nl.json';
import no_no from './localeTranslations/no_no.json';
import pl_pl from './localeTranslations/pl_pl.json';
import pt_br from './localeTranslations/pt_br.json';
import pt_pt from './localeTranslations/pt_pt.json';
import ro_ro from './localeTranslations/ro_ro.json';
import ru_ru from './localeTranslations/ru_ru.json';
import sk_sk from './localeTranslations/sk_sk.json';
import sr_sr from './localeTranslations/sr_sr.json';
import sv_se from './localeTranslations/sv_se.json';
import th_th from './localeTranslations/th_th.json';
import tr_tr from './localeTranslations/tr_tr.json';
import vi from './localeTranslations/vi.json';
import zh_cn from './localeTranslations/zh_cn.json';
import zh_tw from './localeTranslations/zh_tw.json';
// import ukra from './localeTranslations/en_us.json';

const translations = {
  ar: {
    translations: { ...ar },
  },
  cs_cz: {
    translations: { ...cs_cz },
  },
  da_dk: {
    translations: { ...da_dk },
  },
  de_de: {
    translations: { ...de_de },
  },
  el_gr: {
    translations: { ...el_gr },
  },
  en: {
    translations: { ...en },
  },
  en_au: {
    translations: { ...en_au },
  },
  en_ca: {
    translations: { ...en_us },
  },
  en_gb: {
    translations: { ...en_gb },
  },
  en_in: {
    translations: { ...en_in },
  },
  en_us: {
    translations: { ...en_us }, // default en
  },
  en_za: {
    translations: { ...en_us },
  },
  eo: {
    translations: { ...eo },
  },
  es_mx: {
    translations: { ...es_mx },
  },
  es_es: {
    translations: { ...es_es },
  },
  et_ee: {
    translations: { ...et_ee },
  },
  et_et: {
    translations: { ...et_et },
  },
  fi_fi: {
    translations: { ...fi_fi },
  },
  fr_be: {
    translations: { ...fr_be },
  },
  fr_ca: {
    translations: { ...fr_ca },
  },
  fr_fr: {
    translations: { ...fr_fr },
  },
  hu_hu: {
    translations: { ...hu_hu },
  },
  in_id: {
    translations: { ...in_id },
  },
  in_in: {
    translations: { ...in_in },
  },
  is_is: {
    translations: { ...is_is },
  },
  it_it: {
    translations: { ...it_it },
  },
  ja_jp: {
    translations: { ...ja_jp },
  },
  ko_kr: {
    translations: { ...ko_kr },
  },
  lt_lt: {
    translations: { ...lt_lt },
  },
  lv_lv: {
    translations: { ...lv_lv },
  },
  ms: {
    translations: { ...ms },
  },
  nl_be: {
    translations: { ...nl_be },
  },
  nl_nl: {
    translations: { ...nl_nl },
  },
  no_no: {
    translations: { ...no_no },
  },
  pl_pl: {
    translations: { ...pl_pl },
  },
  pt_br: {
    translations: { ...pt_br },
  },
  pt_pt: {
    translations: { ...pt_pt },
  },
  ro_ro: {
    translations: { ...ro_ro },
  },
  ru_ru: {
    translations: { ...ru_ru },
  },
  sk_sk: {
    translations: { ...sk_sk },
  },
  sr_sr: {
    translations: { ...sr_sr },
  },
  sv_se: {
    translations: { ...sv_se },
  },
  th_th: {
    translations: { ...th_th },
  },
  tr_tr: {
    translations: { ...tr_tr },
  },
  ukra: {
    translations: { ...en_us },
  },
  vi: {
    translations: { ...vi },
  },
  zh_cn: {
    translations: { ...zh_cn },
  },
  zh_hk: {
    translations: { ...zh_tw },
  },
  zh_tw: {
    translations: { ...zh_tw },
  },
};

export default translations;
